export default "__VITE_ASSET__BN2JyM0j__"